export default {
  // =========================================================================
  // WSTA CLIENT-SPECIFIC DEMO GROUPS
  // =========================================================================
  wsta_duty_comfort_demo: {
    type: "likert",
    label: "Windfall tax: Hospitality",
    fulltext: "To what extent would you be comfortable with the government imposing a windfall tax on the following industries? Hospitality",
    client: "wsta",
    keys: [
      "pol:windfall:hospitality:comfortable:lik",
      "pol:windfall:hospitality:neutral:lik",
      "pol:windfall:hospitality:uncomfortable:lik",
      "pol:windfall:hospitality:dk:lik"
    ],
    labels: {
      "pol:windfall:hospitality:comfortable:lik":   "Comfortable",
      "pol:windfall:hospitality:neutral:lik":       "Neither",
      "pol:windfall:hospitality:uncomfortable:lik": "Uncomfortable",
      "pol:windfall:hospitality:dk:lik":            "Don't know"
    },
    polarity: {
      pos: "pol:windfall:hospitality:comfortable:lik",
      neu: "pol:windfall:hospitality:neutral:lik",
      neg: "pol:windfall:hospitality:uncomfortable:lik",
      dk:  "pol:windfall:hospitality:dk:lik"
    },
    schema: "tracking",
    waves: [2,3]
  },

  wsta_alcohol_consumption_change: {
    type: "likert",
    label: "Alcohol consumption (Demo Data)",
    fulltext: "Which of the following best describes how your alcohol consumption has changed in the last 12 months? (demo data)",
    client: "wsta",
    keys: [
      "pol:windfall:banks:comfortable:lik",
      "pol:windfall:banks:neutral:lik",
      "pol:windfall:banks:uncomfortable:lik",
      "pol:windfall:banks:dk:lik",
    ],
    labels: {
      "pol:windfall:banks:comfortable:lik":   "No change",
      "pol:windfall:banks:neutral:lik":       "Decreased consumption",
      "pol:windfall:banks:uncomfortable:lik": "Increased consumption",
      "pol:windfall:banks:dk:lik":            "Don't know",
    },
    polarity: {
      pos: "pol:windfall:banks:uncomfortable:lik",
      neu: "pol:windfall:banks:comfortable:lik",
      neg: "pol:windfall:banks:neutral:lik",
      dk:  "pol:windfall:banks:dk:lik",
    },
    schema: "tracking",
    waves: [2,3]
  },

  wsta_duty_approach: {
    type: "categorical",
    label: "Alcohol duty & regulation (Demo data)",
    fulltext: "Thinking about alcohol duty and regulation, which approach is closest to your view? (Demo data)",
    client: "wsta",
    keys: [
      "pol:vi:conservative:cat",
      "pol:vi:labour:cat",
      "pol:vi:libdem:cat",
      "pol:vi:reform:cat",
      "pol:vi:green:cat",
      "pol:vi:other:cat"
    ],
    labels: {
      "pol:vi:conservative:cat": "Freeze or cut duty to ease cost pressures",
      "pol:vi:labour:cat":       "Targeted support for pubs",
      "pol:vi:libdem:cat":       "Simplify duty bands to protect small producers",
      "pol:vi:reform:cat":       "Big duty cuts with fewer restrictions overall",
      "pol:vi:green:cat":        "Stronger health rules and higher duty on ABV",
      "pol:vi:other:cat":        "None of these"
    },
    colors: {
      "pol:vi:conservative:cat": "#1B5E20",
      "pol:vi:labour:cat":       "#6D4C41",
      "pol:vi:libdem:cat":       "#2E7D32",
      "pol:vi:reform:cat":       "#0D47A1",
      "pol:vi:green:cat":        "#B71C1C",
      "pol:vi:snp:cat":          "#4E342E",
      "pol:vi:plaid:cat":        "#33691E",
      "pol:vi:other:cat":        "#757575"
    },
  },
};
